import { render, staticRenderFns } from "./activeCard.vue?vue&type=template&id=2b15ece4&scoped=true&"
import script from "./activeCard.vue?vue&type=script&lang=js&"
export * from "./activeCard.vue?vue&type=script&lang=js&"
import style0 from "./activeCard.vue?vue&type=style&index=0&id=2b15ece4&prod&lang=less&"
import style1 from "./activeCard.vue?vue&type=style&index=1&id=2b15ece4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b15ece4",
  null
  
)

export default component.exports